import {
  CLEAR_ALL,
  GETALL_BANCOS,
  LOADING_GETALL_BANCOS,
  PARAMS_BANCOS,
  SET_ACTIVO_BANCOS,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  meta: null,
  links: null,
  activo: null,
  params: {
    date: null,
    perMonth: true,
  },
  loadingGetAll: false,
};

export const bancosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_BANCOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_ACTIVO_BANCOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_BANCOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_BANCOS:
      return {
        ...state,
        params: action.payload,
      };
    default:
      return state;
  }
};
